import { createSlice } from "@reduxjs/toolkit";
import { getMemberPlans, getAgentPlans, getClubPlans, getScoutPlans } from "./_planAction";

const initialState: any = {
  data: [],
  plans: [],
  agentPlans: [],
  clubPlans: [],
  scoutPlans: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const planList = createSlice({
  name: "planList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getMemberPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getMemberPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.plans = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getMemberPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(getAgentPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getAgentPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        console.log(payload.data,">>> payload Data >>>>")
        state.agentPlans = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getAgentPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })

      .addCase(getClubPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getClubPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        console.log(payload.data,">>> payload Data >>>>")
        state.clubPlans = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getClubPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })

      .addCase(getScoutPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getScoutPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        console.log(payload.data,">>> payload Data >>>>")
        state.scoutPlans = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getScoutPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
